<app-microescapes [config]="config"></app-microescapes>